import AppIcon from '@/images/app-icon.png?url'

import { Spinner } from './ui/spinner'

export default function PendingComponent() {
  return (
    <div className="flex h-dvh w-full flex-col">
      <main className="flex flex-1 flex-col items-center justify-center">
        <img src={AppIcon} alt="App Icon" className="mb-8 size-14" />
        <h1 className="mb-1 text-center text-xl font-semibold">
          Backoffice Desa Wisata
        </h1>
        <p className="text-muted-foreground mb-6 text-center text-sm">
          Please wait a moment...
        </p>
        <Spinner className="text-primary" variant="circle-filled" />
      </main>
      <footer className="flex items-center justify-center py-6">
        <p className="text-muted-foreground mx-auto text-center text-xs">
          &copy; {new Date().getFullYear()}
        </p>
      </footer>
    </div>
  )
}
